/** Pages the admin can show or hide the full-page image ad on. */
export const AD_PAGES: { path: string; label: string }[] = [
  { path: '/', label: 'Dashboard' },
  { path: '/auth', label: 'Login / Sign up' },
  { path: '/exam', label: 'Exam (test writing)' },
  { path: '/results', label: 'Result' },
  { path: '/results-history', label: 'Results History' },
  { path: '/profile', label: 'Profile' },
  { path: '/batch', label: 'Batch' },
  { path: '/exams', label: 'Exam pages (all)' },
  { path: '/exams/groups', label: 'GROUPS exam page' },
  { path: '/exams/si-pc', label: 'SI & PC exam page' },
  { path: '/exams/rrb', label: 'RRB exam page' },
  { path: '/exams/ssc', label: 'SSC exam page' },
  { path: '/subject', label: 'Subject tests' },
  { path: '/public-quiz', label: 'Public Quiz' },
  { path: '/ai-coach', label: 'ISC Coach' },
  { path: '/mistakes', label: 'Mistakes' },
  { path: '/notes', label: 'Notes' },
  { path: '/books', label: 'Books store' },
  { path: '/cart', label: 'Cart' },
  { path: '/checkout', label: 'Checkout' },
  { path: '/my-orders', label: 'My Orders' },
  { path: '/downloads', label: 'Download Files' },
  { path: '/current-affairs', label: 'Current Affairs' },
  { path: '/youtube', label: 'YouTube' },
  { path: '/admin', label: 'Admin' },
];

/** Maps a URL path to its AD_PAGES key ('/index' counts as dashboard). */
export function pageKey(pathname: string): string {
  if (pathname === '/' || pathname === '/index') return '/';
  const match = AD_PAGES
    .filter(p => p.path !== '/' && (pathname === p.path || pathname.startsWith(p.path + '/')))
    .sort((a, b) => b.path.length - a.path.length)[0];
  return match?.path ?? pathname;
}

